
import { DataGrid } from "components/DataGrid/DataGrid";
import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { ModalForm } from "components/ModalForm/ModalForm";
import { Toast } from "components/ToastShow/ToastAlert";
import { Toolbar } from "components/Toolbar/Toolbar";
import { LayoutContext } from "layouts/DashboardLayout/context/LayoutContext";
import { useContext, useEffect, useState } from "react";
import { MessageType } from "types/enum";
import { downloadCSV, getGridSetting, getPageSize, trans } from "utils/helpers";
import { getSalesContract, postResendJobContract } from "./api";
import { SalesContractForm } from "./SalesContractForm";



export const SalesContract = () => {
    const [loading, setLoading] = useState(false);
    const [messageType, setMessageType] = useState<any>("info");
    const [response, setResponse] = useState<any>([]);
    const [selectedObj, setSelectedObj] = useState<string | any>(null);
    const [mode, setMode] = useState("");
    const [forceUpdate, setForceUpdate] = useState(false);
    const [showSalesContractForm, setShowSalesContractrForm] = useState(false);
    const [pageNum, setPageNum] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(25);
    const [search, setsearch] = useState(null);
    const [filterAndSort, setFilterAndSort] = useState<any>(null);
    const layoutContext = useContext(LayoutContext);
    const [pages, setPages] = useState<number>(0);
    const [buttonPrintObj, setButtonPrintObj] = useState<any>()

    const searchHandler = (str) => {
        setPageNum(1);
        setSelectedObj(null)
        if (str === "") {
            setsearch(null)
            getContractAsync(1, null);
        } else {
            setsearch(str)
            getContractAsync(1, str);
        }
    }
const postResendJobContractAsync=async()=>{
    try{
        await postResendJobContract(selectedObj?.Id)
    }
    catch(error){}
}
    const handleChangePageSize = (e: any) => {
        setPageNum(1);
        setPageSize(e.currentTarget.value);
        getPageSize("SalesContractList", e.currentTarget.value)
        getContractAsync(1);
    };
    const handleGoPage = (value) => {
        if (value) {
            setPageNum(+value);
            getContractAsync(+value);
        } else {
        }
    };
    const handleNextPage = () => {
        if (response.TotalRecords && ((response.TotalRecords / pageSize) > pageNum)) {
            setPageNum((pageNum) => { return +pageNum + 1 });
            getContractAsync(pageNum + 1);

        }
    };
    const handlePrevPage = () => {
        if (pageNum > 1) {
            setPageNum((pageNum) => { return +pageNum - 1 });
            getContractAsync(pageNum - 1);
        }
    };



    const selectedObjCallback = (obj, index) => {
        setSelectedObj(obj);
    }

    const handleCreateSalesContract = (id) => {
        setMode("create");
        setShowSalesContractrForm(true)
    }


    /* #region toolbarActions */
    const clickToolbarCallback = (clickedButtonName: string) => {
        switch (clickedButtonName.toLowerCase()) {
            case "print": alert("print "); break;
            case "excel": downloadCSV(response?.Data ,6 ,trans("SalesContractList")); break;
            case "refresh": setForceUpdate(!forceUpdate); break;
            case "create": handleCreateSalesContract(""); break;
            case "view": if (selectedObj) {  setMode("view");setShowSalesContractrForm(true) } else {
                //  Toast(trans("Msg_SelectRow"), "warning")
                Toast(trans("Msg_SelectRow"), MessageType.warning)

                 } break;
            // case "edit": if (selectedObj){setMode("edit");setShowSalesContractrForm(true)}; break;
            case "help": alert("call api help"); break;

        }
    };
    /* #endregion */


    async function getContractAsync(pagNum = pageNum, searchSTR = search) {
        setLoading(false)
        try {
        let pageSizeChangedByUser = getPageSize("SalesContractList")
        setPageSize(pageSizeChangedByUser)
        if(layoutContext.currentApplication!=undefined){
            const res = await getSalesContract(pagNum, pageSizeChangedByUser, searchSTR, filterAndSort?.ContractFormat?.join(","), filterAndSort?.Filterlist)
            if (res.Data.Data.length > 0) {
                setResponse(res.Data)
                
                setPages(res.Data.TotalRecords > pageSizeChangedByUser ? Math.ceil(res.Data.TotalRecords / pageSizeChangedByUser) : 1) ;
                
            }
        }
        } catch (error) {
            setMessageType("error")
        }
        setLoading(true)

    }
    useEffect(() => {
        setSelectedObj(null)
        setResponse(null)
        if(filterAndSort!=null&&layoutContext.currentApplication!=undefined){
            getContractAsync();
        }
    }, [forceUpdate, filterAndSort ,layoutContext.currentApplication]);
    useEffect(() => {
        let settings = getGridSetting("SalesContractList")
        setFilterAndSort({ Filterlist: settings[0], ContractFormat: settings[1] })

    }, []);


    return (
        <>  

            {showSalesContractForm ?
                <ModalForm buttonPrintObj={buttonPrintObj} modalHeight={49} mode={mode} onHide={()=>{setShowSalesContractrForm(false)
            setButtonPrintObj(null)

                }} show={showSalesContractForm} title={"SalesContractForm" } >
                    <SalesContractForm 
                    buttonPrintObjCallBack={setButtonPrintObj}
                        step={1}
                        mode={mode} 
                        relod={()=>{setForceUpdate(!forceUpdate)}}  
                        rowObject={mode == "create" ? null : selectedObj}
                        onHide={()=>{setShowSalesContractrForm(false)
            setButtonPrintObj(null)

                        }} /> 
                </ModalForm>  : null}
            <Toolbar  
            // edit={true}
            create={true}
            view={true} handleSearch={searchHandler} id={selectedObj} emptyList={response?.TotalRecords == 0} search={true} handleClickToolbar={clickToolbarCallback} />
            <div style={{ overflowY: "auto", 
          height: "70vh",
           scrollbarWidth: "thin" }} className="col-lg-12 mt-0">
                {loading ? <>{
                    response?.Data?.length > 0 ?
                        <div className="card">
                            <div className="card-body p-0">
                                <>
                                    <DataGrid
                                        DoubleClick={(obj) => { setSelectedObj(obj); clickToolbarCallback("view") }}
                                        View={true}
                                        ViewParametr={"NotSeen"}
                                        handlefiltering={(str:any) => {str.Filterlist != undefined  ? setFilterAndSort(str) : setFilterAndSort({...filterAndSort, Filterlist:str})}}
                                        filterStr={filterAndSort.Filterlist}
                                        orderFormatList={filterAndSort.ContractFormat}
                                        orderFormat={(contract) => { setFilterAndSort({ ...filterAndSort, ContractFormat: contract }) }}
                                        parentName={"SalesContractList"}
                                        theadData={Object.keys(response.Data[0])}
                                        tbodyData={response.Data}
                                        minCellWidth={80}
                                        selectedRowObjectCallback={selectedObjCallback}
                                        rowSelected={selectedObj}
                                        startIndex={2}
                                        handleView={(e)=>{ setSelectedObj({Id:e}) ;setMode("view");setShowSalesContractrForm(true)}}
                                        handleResend={postResendJobContractAsync}
                                        totalRecords={response.TotalRecords}
                                        pageNum={pageNum}
                                        pageSize={pageSize}
                                        HandleNextPage={handleNextPage}
                                        HandlePrevPage={handlePrevPage}
                                        handlechangePageSize={handleChangePageSize}
                                        first={() => { getContractAsync(pages); setPageNum(pages) }}
                                        end={() => { getContractAsync(1); setPageNum(1) }}
                                        handleGoPage={handleGoPage}
                                    />
                                </>
                            </div>
                        </div>
                        :<Message message={"NoDataForPreview"} type={messageType} />
                        
                }</>
                    : <Loading />
                }
            </div>
        </>

    );
}